import BillingComponent from 'components/Account/BillingComponent/BillingComponent';
import ContainerComponent from 'components/Tool/ContainerComponent/ContainerComponent';
import Footer from 'pages/Client/Footer/Footer';
import Header from 'pages/Client/Header/Header';
import './Billing.css';

function Billing() {
  return (
    <>
      <div className="billing-page layout-full-height">
        <Header />

        <ContainerComponent className="layout-main-content">
          <>
            <BillingComponent />
          </>
        </ContainerComponent>

        <Footer />
      </div>
    </>
  );
}

export default Billing;
